<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M24.0001 18V22M24.0001 30H24.0201M10.1437 38H37.8565C40.9357 38 42.8602 34.6667 41.3206 32L27.4642 8C25.9246 5.33333 22.0756 5.33333 20.536 8L6.67956 32C5.13996 34.6667 7.06446 38 10.1437 38Z"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
